import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export function ThirtyYearsPage() {
  return <div className="min-h-screen bg-white" data-id="element-1655">
      {/* Header */}
      <Header variant="solid" data-id="element-1656" />

      {/* Hero Section */}
      <section className="relative py-20 px-8 mt-20" data-id="element-1657">
        <div className="max-w-4xl mx-auto" data-id="element-1658">
          {/* Breadcrumb */}
          <div className="text-sm text-neutral-500 mb-6" data-id="element-1659">
            <a href="/blog" className="hover:text-brand-pink transition-colors" data-id="element-1660">
              News & Events
            </a>
            <span className="mx-2" data-id="element-1661">/</span>
            <span className="text-neutral-900" data-id="element-1662">
              Cheers to 30 Sparkling Years at Peterson House
            </span>
          </div>

          {/* Title */}
          <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-6" data-id="element-1663">
            Cheers to 30 Sparkling Years at Peterson House
          </h1>

          {/* Featured Image */}
          <div className="relative aspect-[16/9] overflow-hidden bg-gray-300 mb-12" data-id="element-1664">
            <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Gelato-tasting-Peterson-House.jpg" alt="30 Years Anniversary" className="w-full h-full object-cover" data-id="element-1665" />
          </div>

          {/* Content */}
          <article className="max-w-none" data-id="element-1666">
            <p className="text-neutral-600 text-lg leading-relaxed mb-8" data-id="element-1667">
              Last month, we proudly celebrated a milestone that means so much
              to our team, our members, shareholders, and every passionate
              supporter of Peterson House — 30 years of sparkling wine,
              celebration, and community in the heart of the Hunter Valley.
            </p>

            {/* Anniversary Luncheon */}
            <div className="bg-brand-pink/10 border-l-4 border-brand-pink p-8 my-8" data-id="element-1668">
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1669">
                Our 30th Anniversary Luncheon was a day to remember. The grounds
                of Peterson House were alive with the sounds of clinking
                glasses, laughter, and celebration as guests enjoyed a decadent
                feast, flowing bubbles, great music, exciting giveaways, and an
                unforgettable atmosphere. It was a chance to reflect on just how
                far we've come — from humble beginnings to becoming the Hunter
                Valley's most iconic sparkling wine destination.
              </p>
            </div>

            {/* The Journey */}
            <div className="mb-8" data-id="element-1670">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1671">
                Three Decades of Excellence
              </h3>
              <p className="text-neutral-600 text-lg leading-relaxed" data-id="element-1672">
                Over the past three decades, Peterson House has grown and
                evolved, crafting new vintages and varietals every year that
                capture the essence of our region. From our beloved Pink Blush
                Rosé to bold and complex traditional styles, our journey has
                been guided by one vision: to share our love for premium
                sparkling wine.
              </p>
            </div>

            {/* Limited Edition Wine */}
            <div className="bg-neutral-50 p-8 my-8" data-id="element-1673">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1674">
                30 Years Semillon — A Limited Edition
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-4" data-id="element-1675">
                To mark this incredible milestone, we released a truly special
                bottle — our limited-edition 30 Years Semillon. This 30-year
                anniversary wine is a blend of four vintages of Semillon:
              </p>
              <ul className="space-y-3 mb-6" data-id="element-1676">
                <li className="flex items-start gap-3 text-neutral-700" data-id="element-1677">
                  <span className="text-brand-pink mt-1" data-id="element-1678">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1679">
                    <strong data-id="element-1680">1992</strong> — When Peterson House was just an idea
                    of founder Ian Peterson
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-700" data-id="element-1681">
                  <span className="text-brand-pink mt-1" data-id="element-1682">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1683">
                    <strong data-id="element-1684">2007</strong> — When his son Colin drove the
                    expansion beyond the traditional method of sparkling
                    winemaking
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-700" data-id="element-1685">
                  <span className="text-brand-pink mt-1" data-id="element-1686">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1687">
                    <strong data-id="element-1688">2013</strong> — The standout vintage, following six
                    years of continuous growth
                  </span>
                </li>
                <li className="flex items-start gap-3 text-neutral-700" data-id="element-1689">
                  <span className="text-brand-pink mt-1" data-id="element-1690">•</span>
                  <span className="text-lg leading-relaxed" data-id="element-1691">
                    <strong data-id="element-1692">2022</strong> — As granddaughter Savannah steps
                    forward as the next generation to leave her mark on the
                    Peterson legacy
                  </span>
                </li>
              </ul>
              <p className="text-neutral-700 text-lg leading-relaxed" data-id="element-1693">
                With notes of fresh citrus, baked bread, and a touch of honey,
                this elegant wine has both depth and finesse, inviting you to
                savour the past while toasting to the future. Every sip is a
                reminder of the dedication, craft, and love that have gone into
                every bottle over the last 30 years.
              </p>
            </div>

            {/* Thank You */}
            <div className="mb-8" data-id="element-1694">
              <p className="text-neutral-600 text-lg leading-relaxed mb-4" data-id="element-1695">
                To all who have supported us on this journey — thank you. Here's
                to the next 30 sparkling years at Peterson House. May they be
                just as bubbly, bold, and beautiful.
              </p>
              <p className="text-brand-pink text-xl font-medium" data-id="element-1696">
                Cheers 🥂 Peterson House!
              </p>
            </div>

            {/* Call to Action */}
            <div className="bg-brand-pink/5 p-8 my-12 text-center" data-id="element-1697">
              <h3 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-1698">
                Visit Our Cellar Door
              </h3>
              <p className="text-neutral-700 text-lg leading-relaxed mb-6" data-id="element-1699">
                Experience our award-winning sparkling wines and discover what
                makes Peterson House the Hunter Valley's premier sparkling wine
                destination.
              </p>
              <a href="/cellar-door" className="inline-flex items-center gap-2 bg-brand-pink text-white px-8 py-3 hover:bg-brand-pink/90 transition-colors font-medium rounded-none group" data-id="element-1700">
                Visit Cellar Door
                <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-1701" />
              </a>
            </div>

            {/* Back to Blog */}
            <div className="mt-12" data-id="element-1702">
              <a href="/blog" className="inline-flex items-center gap-2 text-brand-pink hover:text-brand-pink/80 transition-colors font-medium" data-id="element-1703">
                ← Back to News & Events
              </a>
            </div>
          </article>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-1704" />
    </div>;
}